var _path, _path2, _path3, _path4, _g, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 102,
    viewBox: "0 0 107 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3873 92C78.2524 92 98.5129 71.8233 98.5129 47.0419C98.4291 22.1767 78.2524 2 53.3873 2C28.4385 2 8.26172 22.1767 8.26172 46.9581C8.26172 71.8233 28.4385 92 53.3873 92Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6044 31.3026C101.5 31.3026 103.037 29.7658 103.037 27.8701C103.037 25.9743 101.5 24.4375 99.6044 24.4375C97.7087 24.4375 96.1719 25.9743 96.1719 27.8701C96.1719 29.7658 97.7087 31.3026 99.6044 31.3026Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.625 17.9071C105.92 17.9071 106.97 16.8576 106.97 15.5629C106.97 14.2683 105.92 13.2188 104.625 13.2188C103.331 13.2188 102.281 14.2683 102.281 15.5629C102.281 16.8576 103.331 17.9071 104.625 17.9071Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41208 77.1835C6.81645 77.1835 8.76557 75.2344 8.76557 72.83C8.76557 70.4257 6.81645 68.4766 4.41208 68.4766C2.00772 68.4766 0.0585938 70.4257 0.0585938 72.83C0.0585938 75.2344 2.00772 77.1835 4.41208 77.1835Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6486_70347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.0468 28.1011V82.6295C85.0468 86.6027 81.8957 89.7539 77.9225 89.7539H28.8743C24.9011 89.7539 21.75 86.6027 21.75 82.6295V11.2493C21.75 7.27614 24.9011 4.125 28.8743 4.125H61.2078C62.9888 4.125 64.6329 4.81003 65.866 6.04309L83.1287 23.3059C84.3618 24.6759 85.0468 26.32 85.0468 28.1011Z",
    fill: "url(#paint0_linear_6486_70347)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6486_70347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.457 4.96875V19.9882C64.457 22.8939 66.9177 25.2185 69.7139 25.2185H84.4069C84.09 24.537 83.6603 23.8955 83.1287 23.3048L65.8659 6.04206C65.4413 5.61743 64.9679 5.2578 64.457 4.96875Z",
    fill: "#D5DDEA"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.915 74.9079H31.49C31.0637 74.9079 30.7227 74.4547 30.7227 73.911C30.7227 73.3672 31.0637 72.9141 31.49 72.9141H42.915C43.3413 72.9141 43.6824 73.3672 43.6824 73.911C43.6824 74.5454 43.3413 74.9079 42.915 74.9079Z",
    fill: "#D5DDEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5262 19.0797H31.8324C31.2348 19.0797 30.7227 18.6196 30.7227 18.0828C30.7227 17.546 31.2348 17.0859 31.8324 17.0859H57.5262C58.1237 17.0859 58.6359 17.546 58.6359 18.0828C58.6359 18.6196 58.1237 19.0797 57.5262 19.0797Z",
    fill: "#D6DCE8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6673 25.0641H31.8256C31.2317 25.0641 30.7227 24.604 30.7227 24.0672C30.7227 23.5304 31.2317 23.0703 31.8256 23.0703H41.5825C42.1764 23.0703 42.6855 23.5304 42.6855 24.0672C42.6855 24.604 42.1764 25.0641 41.6673 25.0641Z",
    fill: "#D6DCE8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7739 59.9531H45.8132H42.511H32.5241C32.1214 59.9531 31.7188 60.3685 31.7188 60.95C31.7188 61.4485 32.0409 61.9469 32.5241 61.9469H42.511H45.8132H75.7739C76.1766 61.9469 76.5793 61.5315 76.5793 60.95C76.4987 60.3685 76.1766 59.9531 75.7739 59.9531Z",
    fill: "#D6DCE8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7724 52.9766H64.638H60.8458H32.5256C32.1222 52.9766 31.7188 53.3919 31.7188 53.9735C31.7188 54.4719 32.0415 54.9704 32.5256 54.9704H60.8458H64.638H75.7724C76.1758 54.9704 76.5793 54.555 76.5793 53.9735C76.4986 53.3919 76.1758 52.9766 75.7724 52.9766Z",
    fill: "#D6DCE8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8455 46H72.952H70.0584H32.5225C32.1206 46 31.7188 46.4154 31.7188 46.9969C31.7188 47.4953 32.0403 47.9938 32.5225 47.9938H70.0584H73.2735H75.7651C76.167 47.9938 76.5689 47.5784 76.5689 46.9969C76.6493 46.4984 76.2474 46 75.8455 46Z",
    fill: "#D6DCE8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7824 39.0117H66.4597H64.149H32.5156C32.1172 39.0117 31.7188 39.4271 31.7188 40.0086C31.7188 40.5071 32.0375 41.0055 32.5156 41.0055H64.149H66.4597H75.7028C76.2605 41.0055 76.5793 40.5901 76.5793 40.0086C76.5793 39.5102 76.2605 39.0117 75.7824 39.0117Z",
    fill: "#D6DCE8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6486_70347",
    x: 13.5998,
    y: 0.0498824,
    width: 79.5973,
    height: 101.929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.07512
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.07512
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6486_70347"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6486_70347",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6486_70347",
    x: 56.3068,
    y: 0.893632,
    width: 36.2497,
    height: 36.5505,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.07512
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.07512
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6486_70347"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6486_70347",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6486_70347",
    x1: 53.3778,
    y1: 2.14432,
    x2: 53.3778,
    y2: 90.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.5c2a27667ba5a895c67946cc021349fd.svg";
export { ForwardRef as ReactComponent };